import axios from "@/libs/api.request";
// 获取列表
export const getList = (data) => {
  return axios.request({
    url: "/cost/summary/index",
    method: "post",
    data,
  });
};

// 获取公共配置
export const getConfig = (params) => {
  return axios.request({
    url: "/common/bindUser",
    method: "get",
    params,
  });
};

export const createBill = (data) => {
  return axios.request({
    url: "/cost/summary/create_bill",
    method: "post",
    data,
  });
};

export const create_send_bill = (data) => {
  return axios.request({
    url: "/cost/summary/create_send_bill",
    method: "post",
    data,
  });
};

export const detail = (id) => {
  return axios.request({
    url: "/cost/summary/cost_details/" + id,
    method: "get",
  });
};

export const income_details = (id) => {
  return axios.request({
    url: "/cost/summary/income_details/" + id,
    method: "get",
  });
};

// 获取代理
export const getIdAgent = (id) => {
  return axios.request({
    url: "/cost/summary/agent/" + id,
    method: "get",
  });
};

// 保存成本
export const saveCost = (data) => {
  return axios.request({
    url: " /cost/summary/add_cost/" + data.id,
    method: "post",
    data,
  });
};

// 批量保存成本
export const saveCosts = (data) => {
  return axios.request({
    url: " /cost/summary/batch_add_cost",
    method: "post",
    data,
  });
};

export const send_fee = (params) => {
  return axios.request({
    url: "/cost/summary/send_fee",
    method: "get",
    params,
  });
};

// 添加备注
export const addRemark = (data) => {
  return axios.request({
    url: "/cost/summary/add_remarks/" + data.id,
    method: "post",
    data,
  });
};


export const unpack_order = (id) => {
  return axios.request({
    url: "/cost/summary/unpack_order/" + id,
    method: "get",
  });
};

export const clearance_fee = (data) => {
  return axios.request({
    url: "/cost/summary/clearance_fee",
    method: "post",
    data,
  });
};

export const task = (params) => {
  return axios.request({
    url: "/cost/customExport/task",
    method: "get",
    params,
  });
};

